export default "__VITE_ASSET__BhUiBR5Q__"